module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.financialClubInfo) ? _c('div', {
    staticClass: "box fclub-info"
  }, [_c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header-wrapper logical-block"
  }, [_c('div', {
    staticClass: "page-header translucent-wrapper",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadFinancialClubPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить фото\n        ")])]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    model: {
      value: (_vm.financialClubInfoObject.title),
      callback: function($$v) {
        _vm.$set(_vm.financialClubInfoObject, "title", $$v)
      },
      expression: "financialClubInfoObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    model: {
      value: (_vm.financialClubInfoObject.description),
      callback: function($$v) {
        _vm.$set(_vm.financialClubInfoObject, "description", $$v)
      },
      expression: "financialClubInfoObject.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "logical-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fclub-info-description page-header-wrapper"
  }, [_c('div', {
    staticClass: "description-wrapper"
  }, [_c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Текст"
    },
    model: {
      value: (_vm.financialClubInfoObject.aboutTitle),
      callback: function($$v) {
        _vm.$set(_vm.financialClubInfoObject, "aboutTitle", $$v)
      },
      expression: "financialClubInfoObject.aboutTitle"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('Editor', {
    staticClass: "p-option color-black",
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": 'aboutDescriptionEditor'
    },
    model: {
      value: (_vm.aboutDescription),
      callback: function($$v) {
        _vm.aboutDescription = $$v
      },
      expression: "aboutDescription"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "logical-block"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fclub-info-description page-header-wrapper"
  }, [_c('div', {
    staticClass: "description-wrapper"
  }, [_c('b-field', [_c('Editor', {
    staticClass: "p-option color-black",
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": 'bottomTextEditor'
    },
    model: {
      value: (_vm.bottomText),
      callback: function($$v) {
        _vm.bottomText = $$v
      },
      expression: "bottomText"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveFinancialClub()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ') + "\n    ")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Описание")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Дополнительный текст")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46c081fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinancialClubInfo/Index.vue
// module id = 941
// module chunks = 0